'use client';

import dynamic from 'next/dynamic';
import { useCallback, useState } from 'react';

// ssr: false keeps `msw/browser` (node: null in MSW 3) out of the SSR graph.
// null outside development so the import is statically dead and never bundled in production.
const MswWorkerStarter =
  process.env.NODE_ENV === 'development'
    ? dynamic(() => import('./msw-worker-starter'), { ssr: false })
    : null;

/**
 * Initialises the MSW browser worker in development mode only.
 *
 * Wraps children and gates rendering until the worker is ready,
 * preventing React Query from fetching before MSW can intercept.
 *
 * In production, renders children immediately.
 */
export function MSWProvider({ children }: { children: React.ReactNode }) {
  const [ready, setReady] = useState(!MswWorkerStarter);
  const markReady = useCallback(() => setReady(true), []);

  if (MswWorkerStarter && !ready)
    return <MswWorkerStarter onDone={markReady} />;

  return <>{children}</>;
}
